import { Avatar, Box, Typography } from '@mui/material'
import React from 'react'
import { Constants } from '../../shared/constants'
import StarIcon from '@mui/icons-material/Star';

const ReviewRatingCom = () => {
    return (
        <Box my={3}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "20px", mb: "10px" }}>
                <Avatar src={Constants.customImages.UserAvatar} sx={{ width: "51px", height: "51px" }} />
                <Typography variant='h6'>Sarah M</Typography>
                <Box>
                {Array.from({ length: 5 }).map((_, index) => (
                    <StarIcon key={index} sx={{ color: "red.main" , fontSize:"25px" }} />
                ))}
                </Box>
                
            </Box>
            <Typography variant='body2' color='grey.400' lineHeight={"22px"}>This course was perfect for building a deeper understanding of algorithms in C++. The instructor did a great job of showing how C++ can be used for more advanced topics like binary trees, graph traversal, and sorting algorithms. What really helped was the hands-on coding exercises that forced me to think critically</Typography>
        </Box>
    )
}

export default ReviewRatingCom